// Turkmen translations
export const tk: Record<string, string> = {
  'menu.dashboard': 'Dolandyryş paneli',
  'menu.customers': 'Müşderiler',
  'menu.products': 'Önümler',
  'menu.users': 'Ulanyjylar',
  'menu.settings': 'Sazlamalar',
  'menu.logout': 'Çykmak',
  'dashboard.title': 'Dolandyryş paneli',
  'dashboard.newOrder': 'Täze sargyt',
  'order.title': 'Täze sargyt',
  'order.customer': 'Müşderi',
  'order.products': 'Önümler',
  'order.total': 'Jemi',
  'users.title': 'Ulanyjylar',
  'users.name': 'At',
  'users.email': 'E-poçta',
  'common.yes': 'Hawa',
  'common.no': 'Ýok',
  'common.cancel': 'Ýatyr',
  'common.save': 'Ýatda sakla',
  'common.search': 'Gözle',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Girmek',
  'login.welcome': 'Hoş geldiňiz, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'E-poçta',
  'signup.phone': 'Telefon',
  'menu.reportsAndAccounting': 'Hasabatlar we buhgalteriýa',
  'menu.systemAndCommunication': 'Ulgam we aragatnaşyk',
};